import React from 'react';
import BottomNav from '../components/BottomNav';

const LeadingLadiesCircle = () => {
  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Leading Ladies Circle</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Empowering Women Leaders</p>
        
        <div className="card">
          <p>
            An exclusive network for influential women leaders. Connect, collaborate, 
            and inspire through curated events and mentorship programs.
          </p>
          
          <div className="service-features">
            <div className="feature-item">
              <h3>Elite Network</h3>
              <p>Connect with successful women across industries</p>
            </div>
            <div className="feature-item">
              <h3>Mentorship</h3>
              <p>Access to experienced leaders and advisors</p>
            </div>
            <div className="feature-item">
              <h3>Exclusive Events</h3>
              <p>Private gatherings and leadership forums</p>
            </div>
          </div>
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default LeadingLadiesCircle;
